<template>
  <div>
    <vxe-grid
      ref="table"
      row-id="custCode"
      round
      resizable
      auto-resize
      highlight-hover-row
      :height="tableHeight"
      :toolbar="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :seq-config="{ startIndex: (tablePage.curPage - 1) * tablePage.pageSize }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(opt, index) in tableOpts"
                :key="index"
                :icon="opt.icon"
                :command="{ opt, data: row }"
                :divided="opt.divided"
                :disabled="opt.disabled ? opt.disabled(row) : false"
              >
                {{ opt.text }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:displayLogo="{ row: { bigImageUrl } }">
        <div class="d-flex">
          <el-image
            :src="bigImageUrl || '/image/static/img/nopic.jpg'"
            :preview-src-list="[bigImageUrl || '/image/static/img/nopic.jpg']"
            style="width: 90px;height: 90px;"
            fit="contain"
          />
        </div>
      </template>
      <template v-slot:displayName="{ row }">
        <div>{{ row.custShortName }}</div>
        <div>{{ row.custName }}</div>
      </template>
      <template v-slot:custStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.custStatus === 'N' || row.custStatus === 'B'
              ? 'danger'
              : row.custStatus === 'P'
              ? 'warning'
              : row.custStatus === 'P'
              ? 'success'
              : ''
          "
        >
          {{ row.v_custStatus }}
        </el-tag>
      </template>
      <template v-slot:displayRegion="{ row }">
        <div v-if="row.regionName">
          <span class="mr-1">{{ $l('table_label_region') || '国家' }}:</span>
          <span>{{ row.regionName }}</span>
        </div>
        <div v-if="row.businessLicense">
          <span class="mr-1">
            {{ $l('table_label_businessLicense') || '税号' }}:
          </span>
          <span>{{ row.businessLicense }}</span>
        </div>
      </template>
      <template v-slot:displayContact="{ row }">
        <div v-if="row.contactMobile">
          <span class="mr-1">
            {{ $l('table_label_contactMobile') || '电话' }}:
          </span>
          <span>{{ row.contactMobile }}</span>
        </div>
        <div v-if="row.custAddress">
          <span class="mr-1">
            {{ $l('table_label_custAddress') || '地址' }}:
          </span>
          <span>{{ row.custAddress }}</span>
        </div>
      </template>
      <template v-slot:displayProperty="{ row }">
        <div v-if="row.v_customerBizType">
          <span class="mr-1">
            {{ $l('table_label_customerBizType') || '类型' }}:
          </span>
          <span>{{ row.v_customerBizType }}</span>
        </div>
        <div v-if="row.v_customerType">
          <span class="mr-1">
            {{ $l('table_title_customerType') || '性质' }}:
          </span>
          <span>{{ row.v_customerType }}</span>
        </div>
        <div>
          <span class="mr-1">
            {{ $l('table_label_riskLevel') || '风险' }}:
          </span>
          <el-tag
            size="mini"
            :type="
              !row.riskLevel
                ? 'info'
                : row.riskLevel === 'normal'
                ? 'success'
                : row.riskLevel === 'lowRisk'
                ? 'warning'
                : 'danger'
            "
          >
            {{ row.v_riskLevel || $l('table_label_riskLevel_no') || '未评估' }}
          </el-tag>
        </div>
      </template>
      <template v-slot:displayCreate="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>
      <template v-slot:displayModify="{ row }">
        <span>{{ row.modifyByName }}</span>
        <br />
        <span>{{ row.modifyDate }}</span>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data mt-2">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import TableAutoHeight from '@/mixins/table-auto-height'
import tableOpts from './table-opts'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  data() {
    return {
      tableToolbar: {
        slots: { buttons: 'toolbar_form' },
        refresh: { query: () => this.$emit('reload') },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
  computed: {
    tableOpts() {
      const opts = tableOpts(this)
      return opts.filter(({ allow }) => (!allow ? true : this.allow(allow)))
    },
  },
  methods: {
    optCommand({ opt, data }) {
      const { menuType } = opt
      const { custCode, custNo } = data

      switch (menuType) {
        case 'detail':
        case 'edit':
          this.$emit('openEditPage', {
            pageType: menuType,
            params: { custCode },
          })
          break
        case 'detailV2':
          this.$router.push({
            name: 'customerManage-myCust-detail',
            params: { custCode },
            query: { custNo },
          })
          break
        case 'editV2':
          this.$emit('openEditPageV2', {
            pageType: menuType,
            params: { custCode },
            query: { custNo },
          })
          break
        case 'delete':
          this.del(data)
          break
        case 'apply':
          this.apply(data)
          break
        case 'change':
          this.$emit('change', data)
          break
      }
    },
    async del({ custCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)

      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api.custInfoDelApi({ custCode }).catch(() => null)
      this.loadingClose()
      if (!res) return

      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_delete_no') || '删除失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
    async apply({ custCode }) {
      const confirm = await this.$confirm(
        this.$l('INDEX.tips_question_audit') || '是否审核?',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const params = {
        custCode,
        linkUrl: this.$joinURL(`/opview/customer/${custCode}`, {
          joinOrigin: true,
          joinBasePath: false,
        }),
      }
      const res = await this.$api
        .masterCustomerOaAddAuditApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_operate_no') || '操作失败！')
        return
      }
      this.$message({
        message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
        type: 'success',
      })
      this.$emit('reload')
    },
  },
}
</script>
